import { connect } from "react-redux";
import { Modal } from "bootstrap";
import { Link } from 'react-router-dom';
import swal from "sweetalert";
import AppBaseComponent from '../../components/AppBaseComponent';
import HttpAPICall from "../../services/HttpAPICall";
import tapIcon from "../../services/TapIcon";
import Ax from "../../components/hoc/Ax"
import React from "react";
import { INVENTORY_API_BASE_URL_2 } from "../../services/TapApiUrls";
import InputItemSearch from '../includes/ui/InputItemSearch';
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import InterchangeableItemModal from "./InterchangeableItemModal";


class InterchangeableItem extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.initInterchangeable = {
            item_id_2: null,
            notes: ''
        }
        this.state = {
            itemId: this.props.item_enc_id,
            itemName: this.props.itemName || '',
            listing_tbl_page: 1,
            listingData: [],
            listingMeta: [],
            totalListingCount: 0,
            listing_loading: false,
            searchedItem: null,
            editFormSubmiting: false,
            edit: false,
            addInterchangeableForm: { ...this.initInterchangeable },
            notes: '',
            id: ''
        }

        this.itemUrl = INVENTORY_API_BASE_URL_2 + '/item';
        this.linkInterchangeableModal = null;
    }

    componentDidMount() {
        if (this.props.item_enc_id) {
            this.loadListingTblData(1, this.props.item_enc_id);
        }
        // Initialize modal only if we're in a context with document
        if (typeof document !== 'undefined') {
            this.linkInterchangeableModal = new Modal(document.getElementById('linkInterchangeableModal'), { 
                keyboard: false, 
                backdrop: false 
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.item_enc_id !== this.props.item_enc_id) {
            this.setState({ 
                itemId: this.props.item_enc_id, 
                itemName: this.props.itemName || '' 
            }, () => {
                this.loadListingTblData(1, this.props.item_enc_id);
            });
        }
    }

    loadListingTblData = (page = 1, id) => {
        if (!id) return;
        
        this.setState({ listing_loading: true, listing_tbl_page: page });
        HttpAPICall.withAthorization('GET', this.itemUrl + '/interchangeable_item/' + id, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                listingData: respData.data,
                listingMeta: respData.meta,
                totalListingCount: respData.meta.total,
                notes: respData.notes,
                id: respData.id,
            });
        }).finally(() => this.setState({ listing_loading: false }));
    }

    closeModal = () => {
        this.setState({ 
            addInterchangeableForm: { ...this.initInterchangeable }, 
            searchedItem: null 
        });
    }

    linkInterchangeableInit = () => {
        this.setState({ edit: false });
        this.linkInterchangeableModal?.show();
    }

    // Remove or conditionally use routing
    changeTab = (key) => {
        // Only use routing if history exists (not in modal)
        if (this.props.history && this.props.location) {
            let ParamObject = new URLSearchParams(this.props.location.search);
            let itemName, itemCategory;
            if (ParamObject.get('item_name')) {
                itemName = ParamObject.get('item_name');
            }
            if (ParamObject.get('item_category')) {
                itemCategory = ParamObject.get('item_category');
            }
            let obj = { item_name: itemName, item_category: itemCategory };
            this.props.history.push({ 
                pathname: `/item_list/${key}/${this.state.itemId}`, 
                search: "?" + new URLSearchParams(obj).toString()
            });
        }
    }

    editInterchangeable = (id) => {
        this.setState({ edit: true });
        this.linkInterchangeableModal?.show();

        this.setState({
            addInterchangeableForm: {
                id: this.state.id,
                notes: this.state.notes
            }
        });
    }

    deLinkItem = (id) => {
        swal({
            title: "DeLink Item",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            buttons: ["No", "Yes"],
        })
        .then(willDelete => {
            if (willDelete) {
                let frmData = {
                    item_id_1: this.state.itemId,
                    item_id_2: id
                };
                HttpAPICall.withAthorization('PUT', this.itemUrl + '/unlink_interchangeable_item', this.props.access_token, {}, { ...frmData }, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    this.loadListingTblData(1, this.state.itemId);
                });
            }
        });
    }

    submitlinkItemForm = (e) => {
        e.preventDefault();
        this.setState({ editFormSubmiting: true });
        
        if (this.state.itemId === this.state.addInterchangeableForm.item_id_2) {
            toast.error("Both Items cannot be same, Please select another item for Interchangeable", { 
                position: toast.POSITION.TOP_RIGHT 
            });
            this.setState({ editFormSubmiting: false });
        } else {
            if (this.state.edit === true) {
                let frmData = {
                    ...this.state.addInterchangeableForm
                };
                HttpAPICall.withAthorization('PUT', this.itemUrl + '/note_interchangeable_item', this.props.access_token, {}, { ...frmData }, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    this.linkInterchangeableModal?.hide();
                    this.loadListingTblData(1, this.state.itemId);
                    this.setState({ 
                        addInterchangeableForm: { ...this.initInterchangeable }, 
                        searchedItem: null,
                        edit: false 
                    });
                }).finally(() => this.setState({ editFormSubmiting: false }));
            } else {
                let frmData = {
                    item_id_1: this.state.itemId,
                    ...this.state.addInterchangeableForm
                };
                HttpAPICall.withAthorization('POST', this.itemUrl + '/add_interchangeable_item', this.props.access_token, {}, { ...frmData }, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    this.linkInterchangeableModal?.hide();
                    this.loadListingTblData(1, this.state.itemId);
                    this.setState({ 
                        addInterchangeableForm: { ...this.initInterchangeable }, 
                        searchedItem: null 
                    });
                }).finally(() => this.setState({ editFormSubmiting: false }));
            }
        }
    }

    linkInterchangeableModalJsx = () => {
        return (
            <div className="modal fade" id="linkInterchangeableModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addAssetModalLabel">Link Interchangeable with Item</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={this.submitlinkItemForm} id="addModalForm">
                            <div className="modal-body">
                                {this.state.edit === false && (
                                    <div className="row align-items-center mb-3 mt-3">
                                        <div className="col-md-4">
                                            <label className="form-label">Item Search</label>
                                        </div>
                                        <div className="col-md-8">
                                            <InputItemSearch
                                                required={true}
                                                changeEvent={(selectedOption) => {
                                                    this.tapSelectChange(selectedOption, 'addInterchangeableForm', 'item_id_2');
                                                    this.setState({
                                                        searchedItem: selectedOption || null
                                                    });
                                                }}
                                                disabled={this.state.edit === true}
                                                value={this.state.searchedItem ? { 
                                                    ...this.state.searchedItem, 
                                                    label: this.state.searchedItem.display_label 
                                                } : null}
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="row align-items-center mb-3 mt-3">
                                    <div className="col-md-4">
                                        <label className="form-label">Notes</label>
                                    </div>
                                    <div className="col-md-8">
                                        <textarea
                                            name="notes"
                                            className="form-control"
                                            value={this.state.addInterchangeableForm.notes}
                                            onChange={(e) => this.formInputHandler(e, 'addInterchangeableForm')}
                                            style={{ height: "80px" }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button 
                                    type="button" 
                                    className="btn btn-secondary" 
                                    disabled={this.state.editFormSubmiting} 
                                    data-bs-dismiss="modal" 
                                    onClick={this.closeModal}
                                >
                                    Close
                                </button>
                                <button 
                                    type="submit" 
                                    className="btn btn-primary" 
                                    disabled={this.state.editFormSubmiting}
                                >
                                    Save {this.state.editFormSubmiting ? (
                                        <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />
                                    ) : null}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    render = () => {
        const { hideHelmet } = this.props;
        
        return (
            <Ax>
                {!hideHelmet && <Helmet><title>Interchangeable Item</title></Helmet>}
                <section className="item_view_container bg-white">
                    <InterchangeableItemModal item_enc_id={this.state.itemId} />
                    {this.linkInterchangeableModalJsx()}
                </section>
            </Ax>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token
    };
};

export default connect(mapStateToProps)(InterchangeableItem);